import { debounce } from 'lodash';
import { endpoints } from '@/config';
import api from './api';

function decodeSettings(settingsObj) {
  if (typeof settingsObj !== 'object') {
    return JSON.parse(settingsObj);
  }
  const parsedObject = {};
  Object.keys(settingsObj).forEach((k) => {
    try {
      parsedObject[k] = JSON.parse(settingsObj[k]);
    } catch (e) {
      parsedObject[k] = settingsObj[k];
    }
  });
  return parsedObject;
}

function encodeSettings(settingsObj) {
  const parsedObject = {};
  Object.keys(settingsObj).forEach((k) => {
    parsedObject[k] = JSON.stringify(settingsObj[k]);
  });
  return parsedObject;
}

export function getAccountSettings() {
  return api.get(endpoints.settings)
    .then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new Error('Could not fetch account settings'));
      }
      const { data: { account } } = response;
      return Promise.resolve(decodeSettings(account));
    });
}

export function setAccountSettings(newSettingsObject) {
  const update = { account: encodeSettings(newSettingsObject) };
  return api.post(endpoints.settings, update)
    .then((response) => {
      const { data: { account } } = response;
      return Promise.resolve(decodeSettings(account));
    });
}

export function getUserSettings() {
  return api.get(endpoints.settings)
    .then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new Error('Could not fetch account settings'));
      }
      const { data: { user } } = response;
      return Promise.resolve(decodeSettings(user));
    });
}

let updates = [];
let mostRecentFullSettings = {};
let updatePromise = null;

const debouncedUpdate = debounce((resolve) => {
  // Base the update on the most recent full object
  const updateObject = { ...mostRecentFullSettings };
  // Run all of the previous updates in order
  updates.forEach(({ key, value }) => {
    updateObject[key] = value;
  });

  const update = { user: encodeSettings(updateObject) };
  return api.post(endpoints.settings, update)
    .then((response) => {
      const { data: { user } } = response;
      updates = [];
      return resolve(decodeSettings(user));
    });
}, 1000);

export function setUserSettings(newSettingsObject, affectedKeys) {
  mostRecentFullSettings = { ...newSettingsObject };
  affectedKeys.forEach((key) => {
    updates.push({ key, value: newSettingsObject[key] });
  });

  // Only run one debounced version at a time, all return same promise
  if (!updatePromise) {
    updatePromise = new Promise((resolve) => {
      debouncedUpdate(resolve);
    }).then((result) => {
      updatePromise = null;
      updates = [];
      return Promise.resolve(result);
    });
  }
  return updatePromise;
}
